var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{thumb:true, blocked:_vm.blocked},on:{"click":function($event){_vm.toggle(_vm.postData)}}},[_c('div',{attrs:{"id":"date"}},[_vm._v(_vm._s(_vm.formatDate(_vm.postData.createdAt)))]),_vm._v(" "),_c('img',{attrs:{"src":_vm.postData.post.thumbnail_resources[3].src}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48209502","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/instagram/InstagramPost.vue
// module id = null
// module chunks = 